import type { ConnectorTool, ConnectorToolGroup } from "@/lib/api";

/**
 * Whether the connector serves this tool now. A "coming soon" tool is listed
 * on the Tools page only: Claude cannot use it yet.
 */
export function isServed(tool: Pick<ConnectorTool, "status">): boolean {
  return tool.status === "available";
}

/**
 * The tools the connector serves, in the catalogue's order. Every page but
 * Tools (the Docs page, Analytics) shows these alone.
 */
export function servedTools<T extends Pick<ConnectorTool, "status">>(tools: readonly T[]): T[] {
  return tools.filter(isServed);
}

/** One group of the catalogue (`GET /mcp/overview`) with its tools. */
export interface GroupedTools<T> extends ConnectorToolGroup {
  tools: T[];
}

/**
 * The tools under their group: the groups in the catalogue's order, each
 * group's tools in theirs. A group without tools is left out.
 */
export function toolsByGroup<T extends Pick<ConnectorTool, "group">>(
  groups: readonly ConnectorToolGroup[],
  tools: readonly T[],
): GroupedTools<T>[] {
  return groups
    .map((group) => ({ ...group, tools: tools.filter((tool) => tool.group === group.id) }))
    .filter((group) => group.tools.length > 0);
}
